import testForErrCode from './test-for-err-code'

const codes = {
  members: {
    rootMember: '[error:2.1]',
    cardNumberMaxLen: '[error:2.11]',
    isBusyCardName: '[error:2.12]',
    lastNameMinLen: '[error:2.13]',
    lastNameMaxLen: '[error:2.14]',
    firstNameMinLen: '[error:2.15]',
    firstNameMaxLen: '[error:2.16]',
    patronymicMinLen: '[error:2.17]',
    patronymicMaxLen: '[error:2.18]',
    mobilePhoneNumber: '[error:2.19]',
    isBusyTelefon: '[error:2.20]'
  },
  organization: {
    rootOrg: '[error:1.1]',
    organizationHasChildren: '[error:1.101]',
    organizationHasMember: '[error:1.102]',
    officialNameMinLen: '[error:1.11]',
    officialNameMaxLen: '[error:1.12]',
    shortNameMinLen: '[error:1.13]',
    shortNameMaxLen: '[error:1.14]',
    shortNameNeqOfficialName: '[error:1.15]'
  },
  document: {
    documentNameMinLen: '[error:4.11]',
    documentNameMaxLen: '[error:4.12]',
    fileExt: '[error:3.22]',
    fileSize: '[error:3.11]'
  }
}

export default codes

export function isUnknownError (errorMsg, entity) {
  const entityCodes = codes[entity]
  for (const key in entityCodes) {
    if (entityCodes.hasOwnProperty(key) &&
        testForErrCode(entityCodes[key], errorMsg)) {
      return false
    }
  }

  return true
}



// WEBPACK FOOTER //
// ./src/utils/error-codes.js